import type { GuestOs } from './api.js';

/**
 * One-shot, in-memory handoff of a chosen sample from the Submit page to the interactive Live-VM
 * page. Avoids stuffing a (potentially large) base64 blob into router state or the URL. Consumed
 * exactly once by the Live page on mount.
 */
export interface PendingLiveSample {
  fileName: string;
  fileBase64: string;
  os?: GuestOs;
  network?: 'full' | 'simulated' | 'none';
}

let pending: PendingLiveSample | null = null;

export function setPendingLiveSample(sample: PendingLiveSample): void {
  pending = sample;
}

export function takePendingLiveSample(): PendingLiveSample | null {
  const s = pending;
  pending = null;
  return s;
}
